import { useQuoteI18n } from '../quoteI18n'
import { OfferCard } from './OfferCard'

const SECTION_ICONS = { air: '✈️', rail: '🚄', hotel: '🏨', car: '🚗' }

/**
 * Una **tratta** del preventivo, con le sue offerte selezionabili.
 *
 * Non è per verticale: un A/R in treno produce due sezioni (andata e ritorno) e il
 * viaggiatore scegli un'offerta in ciascuna. Il raggruppamento lo fa `buildLegGroups`.
 *
 * @param {Object} props
 * @param {string} props.serviceKey - air | rail | hotel | car (serve per l'icona)
 * @param {string} [props.title] - Titolo della sezione; default: il nome del verticale
 * @param {Array} props.offers - Offerte della tratta
 * @param {Object} [props.selectedOffer] - L'offerta scelta per questa tratta, se c'è
 * @param {(offer: Object) => void} props.onToggle - Seleziona/deseleziona un'offerta
 */
export function ServiceSection({ id, serviceKey, title, offers, selectedOffer, onToggle }) {
  const { t } = useQuoteI18n()
  if (!offers?.length) return null

  return (
    <section id={id} className="gq-section">
      <div className="gq-section__head">
        <span className="gq-section__icon" aria-hidden="true">
          {SECTION_ICONS[serviceKey] || '📋'}
        </span>
        <h2 className="gq-section__title">{title || t.services[serviceKey] || serviceKey}</h2>
        <span className="gq-section__count">{t.services.offers(offers.length)}</span>
        {!selectedOffer && <span className="gq-section__hint">{t.services.noChoice}</span>}
      </div>

      {offers.map((offer) => (
        <OfferCard
          key={offer.offerId}
          offer={offer}
          selected={selectedOffer?.offerId === offer.offerId}
          onToggle={onToggle}
        />
      ))}
    </section>
  )
}
